import PropTypes from 'prop-types';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import React from 'react';

const TableauArmeASupprimer = ({ donnees }) => {
    const tableauConfigHeader = [
        "Numéro d'encodage",
        'Numéro de série',
        'Type',
        'Marque',
        'Modèle',
        'Calibre Canon 1',
        'Calibre Canon 2',
        'Classement',
        donnees.length > 1 ? 'Actions' : null,
    ];

    return (
        <SimpleTable
            entete={tableauConfigHeader}
            donnees={donnees.map((elem) => {
                return Object.values(elem);
            })}
        />
    );
};

TableauArmeASupprimer.propTypes = {
    donnees: PropTypes.array.isRequired,
};

export default TableauArmeASupprimer;
